import React, { Component } from 'react';
import InputMask from 'react-input-mask';

class ServiceRow extends Component{
  constructor(props){
    super(props);
    this.state = {
      service:null,
      orig_price:0
    }
  }

  componentDidMount(){
    this.setState({
      service:this.props.service,
      orig_price:this.props.service.price
    })
  }


  handleInputChange = (e) => {
    let updated_service = Object.assign({}, this.state.service);
    updated_service[e.target.name] = e.target.value;
    this.setState({service:updated_service});
  }


  render(){
    if (!this.state.service) return <tr><td colSpan="4">Loading Service</td></tr>;
    const {service, orig_price} = this.state;
    if (!service.quantity){
      service.quantity = 1
    }
    const { addHandler } = this.props;
    return (
      <tr>
          <td className="">{service.name}<br/><p className="fs-10 text-truncate w-300px">{service.description}</p></td>
          <td className="">${orig_price}</td>
          <td className="">
            <input className="form-control col-sm-8" name="price" type="number" step=".1" value={service.price} onChange={this.handleInputChange}/>
          </td>
          <td className="">
            <input className="form-control col-sm-6" name="quantity" type="number" step="1" value={service.quantity} onChange={this.handleInputChange}/>
          </td>
          <td className=""><button className="btn btn-sm btn-primary pull-right" onClick={()=>addHandler(service)}>Add</button></td>
      </tr>
    );
  }
}

class ModalBookingServices extends Component {
  render() {
    if (!this.props.booking || !this.props.service_list) return <div className="alert alert-danger">No Booking Loaded</div>;
    return (
    	<React.Fragment>
        <table className="table">
            <thead>
              <tr>
                <th width="30%">Service</th>
                <th width="10%">Price</th>
                <th width="20%">Override Price</th>
                <th width="20%">Qty</th>
                <th width="20%"></th>
              </tr>
            </thead>
            <tbody>
            {this.props.service_list.map((service, service_index) =>
              <ServiceRow key={service_index} service={service} addHandler={this.props.addServiceHandler}/>
            )}
            </tbody>
        </table>
      </React.Fragment>
    );
  }
}

export default ModalBookingServices;



// WEBPACK FOOTER //
// ./src/components/business/ModalBookingServices.js